/*
 * @Description:
 * @Date: 2024-02-18 17:23:11
 */
export const topicData = [
  {
    resultSystem:
      '本次参与“您最近完成的项目调研数量”的反馈样本中，选择“1-60单”的共计1⼈，占⽐4.76%， 有效占比4.76%，累计百分⽐为 4.76%；选择“61-120单”的共计2⼈，占⽐9.52%，有效占比9.52%，累计百分⽐为14.28%；选择“121-180单”的共计3⼈，占⽐ 14.28%，有效占比14.28%，累计百分⽐为28.57%；选择“181-240单”的共计4⼈，占⽐19.05%，有效占比19.05%， 累计百分⽐为47.62%；选择“241-300单”的共计11⼈，占⽐52.38%，有效占比为52.38%，累计百分⽐为100.00%。',
    resultUser: '',
    echart: {
      '1-60单': [1],
      '61-120单': [2],
      '121-180单': [3],
      '181-240单': [4],
      '241-300单': [11]
    },
    tableChartType: 'pc-module-task-percent-1',
    isDelete: 0,
    tableMedian: {
      header: [
        { prop: 'title', label: [''] },
        { prop: 'median', label: ['中位数'] },
        { prop: 'modeNum', label: ['众数'] },
        {
          prop: 'percentileNum',
          label: ['百分位数'],
          subHeaderList: [
            { prop: 'percentileNum25', label: ['25'] },
            { prop: 'percentileNum50', label: ['50'] },
            { prop: 'percentileNum75', label: ['75'] }
          ]
        }
      ],
      value: [
        {
          median: ['241-300单'],
          modeNum: ['241-300单'],
          percentileNum25: ['121-180单'],
          percentileNum50: ['241-300单'],
          percentileNum75: ['241-300单'],
          title: ['项目参与人完成任务的区间分布']
        }
      ]
    },
    title: '您最近完成的项目调研数量',
    medianResultUser: '',
    medianResultSystem:
      '本次参与“您最近完成的项目调研数量”的反馈样本中，中位数为“241-300单”，这表示将所有数据从小到大排列后，位于中间位置的数值是“241-300单”；众数为“241-300单”，这表示出现次数最多的数值为“241-300单”；百分位数是描述一组数据中某个特定百分比处的取值。本组数据中“25”百分位数为“121-180单”，“50”百分位数为“241-300单”，“75”百分位数为“241-300单”。',
    table: {
      header: [
        { prop: 'numRange', label: ['选项'] },
        { prop: 'peopleNum', label: ['数量'] },
        { prop: 'rate', label: ['本次占比'] },
        { prop: 'effectivePercentage', label: ['有效占比'] },
        { prop: 'accumulativePercentage', label: ['累计百分比'] },
        { prop: 'accumulativePercentage1', label: ['累计占比'] }
      ],
      value: [
        {
          numRange: ['1-60单'],
          peopleNum: ['1'],
          rate: ['4.76%'],
          effectivePercentage: ['4.76%'],
          accumulativePercentage: ['4.76%'],
          accumulativePercentage1: ['4.76%']
        },
        {
          numRange: ['61-120单'],
          peopleNum: ['2'],
          rate: ['9.52%'],
          effectivePercentage: ['9.52%'],
          accumulativePercentage: ['14.28%'],
          accumulativePercentage1: ['9.52%']
        },
        {
          numRange: ['121-180单'],
          peopleNum: ['3'],
          rate: ['14.29%'],
          effectivePercentage: ['14.29%'],
          accumulativePercentage: ['28.57%'],
          accumulativePercentage1: ['14.29%']
        },
        {
          numRange: ['181-240单'],
          peopleNum: ['4'],
          rate: ['19.05%'],
          effectivePercentage: ['19.05%'],
          accumulativePercentage: ['47.62%'],
          accumulativePercentage1: ['19.05%']
        },
        {
          numRange: ['241-300单'],
          peopleNum: ['11'],
          rate: ['52.38%'],
          effectivePercentage: ['52.38%'],
          accumulativePercentage: ['100.00%'],
          accumulativePercentage1: ['52.38%']
        }
      ]
    }
  }
];
